import { TableColumn } from '@/typing';
import { getDate, getDateTime, getTime2 } from '@/utils/function';
export default (current_org: any) => {
  const None = null;
  const True = true;
  const False = false;
  const baseColumns: TableColumn[] = [
    {
      title: '序号',
      dataIndex: 'index',
      width: 50,
      fixed: 'left',
    },
    {
      title: '创建时间',
      width: 150,
      dataIndex: 'create_time',
      checked: true,
      resizable: true,
      content: (record: any, text: any) => getDateTime(text),
    },
    {
      title: '路由',
      width: 150,
      dataIndex: 'route',
      checked: true,
      resizable: true,
    },
    {
      title: '名称',
      width: 150,
      dataIndex: 'name',
      checked: true,
      resizable: true,
    },
    {
      title: '调用人',
      width: 150,
      dataIndex: 'realname',
      checked: true,
      resizable: true,
    },
    {
      title: '耗时',
      width: 150,
      dataIndex: 'used_time',
      checked: true,
      resizable: true,
    },
    {
      title: '执行状态',
      width: 150,
      dataIndex: 'status',
      checked: true,
      resizable: true,
      cellComponent: 'tag',
      content: (record: any, text: any) => {
        switch (text) {
          case 0:
            return '开始';
          case 1:
            return '进行中';
          case 2:
            return '成功';
          case 3:
            return '警告';
          case 4:
            return '错误';
        }
      },
      color: (record: any, text: any) => {
        switch (text) {
          case 0:
            return 'green';
          case 1:
            return 'cyan';
          case 2:
            return 'blue';
          case 3:
            return 'purple';
          case 4:
            return 'pink';
        }
      },

      filterMultiple: true,
      filters: [
        { text: '全部', value: '' },
        { text: '开始', value: '0' },
        { text: '进行中', value: '1' },
        { text: '成功', value: '2' },
        { text: '警告', value: '3' },
        { text: '错误', value: '4' },
      ],
    },
    {
      title: '日志ID',
      width: 150,
      dataIndex: 'request_id',
      checked: true,
      resizable: true,
    },
    {
      title: '用户ID',
      width: 150,
      dataIndex: 'user_id',
      checked: true,
      resizable: true,
    },
    {
      title: '最高等级日志',
      width: 150,
      dataIndex: 'max_level',
      checked: true,
      resizable: true,
      cellComponent: 'tag',
      content: (record: any, text: any) => {
        switch (text) {
          case 5:
            return '基础信息';
          case 10:
            return '调试';
          case 20:
            return '信息';
          case 25:
            return '数据成功';
          case 30:
            return '数据异常';
          case 40:
            return '逻辑错误';
          case 50:
            return '程序崩溃';
        }
      },
      color: (record: any, text: any) => {
        switch (text) {
          case 5:
            return 'cyan';
          case 10:
            return 'blue';
          case 20:
            return '#108ee9';
          case 25:
            return 'green';
          case 30:
            return 'orange';
          case 40:
            return 'red';
          case 50:
            return '#f50';
        }
      },

      filterMultiple: true,
      filters: [
        { text: '全部', value: '' },
        { text: '基础信息', value: '5' },
        { text: '调试', value: '10' },
        { text: '信息', value: '20' },
        { text: '数据成功', value: '25' },
        { text: '数据异常', value: '30' },
        { text: '逻辑错误', value: '40' },
        { text: '程序崩溃', value: '50' },
      ],
    },
    {
      title: '项目',
      width: 150,
      dataIndex: 'project',
      checked: true,
      resizable: true,
    },
    {
      title: '项目分类ID',
      width: 150,
      dataIndex: 'id',
      checked: false,
      resizable: true,
    },

    {
      title: '操作',
      width: 200,
      dataIndex: 'action',
      fixed: 'right',
      cellComponent: 'action',
    },
  ];

  return {
    baseColumns: baseColumns,
  };
};
